import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import useCompany from '../hooks/useCompany';
import CustomNavigate from '../components/CustomNavigate';

export default function RWAModuleMiddleware({ children }) {
    const { activeCompany } = useCompany();

    if (!activeCompany) return <CustomNavigate to="/dashboard/home" />;

    const modules = activeCompany?.modules || [];

    const hasRwaModule = modules.some((module) => 
        typeof module === 'string' ? module === 'rwa_module' : module.slug === 'rwa_module'
    );

    if (!hasRwaModule) return <CustomNavigate to="/dashboard/home" />;

    return children;
}

RWAModuleMiddleware.propTypes = {
    children: PropTypes.node.isRequired,
};